import * as React from "react";
import axios from "axios";

import { grey } from "@mui/material/colors";

import { useState, useEffect } from "react";
import { Alert, Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Typography, Box, Stack, InputAdornment, Select, MenuItem } from "@mui/material";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Backdrop, CircularProgress } from '@mui/material';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';
import { normalizeApiMoney, parseColombianMoneyInput } from '../../../utils/money';

const API_URL = process.env.REACT_APP_API_URL;
const getId = (value) => (value && typeof value === 'object' ? value.id : value);
const hasValidId = (value) => {
  const id = getId(value);
  return id !== null && id !== undefined && id !== '' && typeof id !== 'object';
};

async function actualizarReporteDiario(valorAnterior, valorNuevo, fechaInicio) {
  try {
    const response = await axios.get(`${API_URL}/reporte_diario/`);

    const reportes = response.data;
    const reporteMensualidad = reportes.find(r => r.fecha === fechaInicio && r.tipo === "E-I");

    if (reporteMensualidad) {
      const nuevoValor = ((parseFloat(reporteMensualidad.valor) - Number(valorAnterior)) + Number(valorNuevo)).toFixed(2);

      const responsePut = await axios.put(`${API_URL}/reporte_diario/${reporteMensualidad.id}/`, { valor: nuevoValor });
    }
  } catch (error) {
    console.error("Error en la actualización del reporte:", error);
  }
}

function convertirFecha(fechaDDMMYYYY) {
  const [dia, mes, anio] = fechaDDMMYYYY.split("/");
  return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
}

export default function DialogModifyEstadias({ openDialog, handleCloseDialog, data, handleUpdateData, setValorModificableParaVer }) {
  const [fechaEntrada, setFechaEntrada] = useState(data?.entrada?.fecha_entrada ? new Date(`${data.entrada.fecha_entrada}T00:00:00`) : null);
  const [horaEntrada, setHoraEntrada] = useState(data?.entrada?.hora_entrada ? new Date(`1970-01-01T${data.entrada.hora_entrada}`) : null);
  
  const [fechaSalida, setFechaSalida] = useState(data?.salida?.fecha_salida ? new Date(`${data.salida.fecha_salida}T00:00:00`) : null);
  const [horaSalida, setHoraSalida] = useState(data?.salida?.hora_entrada ? new Date(`1970-01-01T${data.salida.hora_entrada}`) : null);

  const [tarifasData, setTarifasData] = useState([]);
  const [tarifa, setTarifa] = useState(data.tarifa.id)

  const [tiempoTranscurrido, setTiempoTranscurrido] = useState('??');
  const [tiempoTranscurridoMin, setTiempoTranscurridoMin] = useState(0);
  const [valor, setValor] = useState(data?.salida?.valor_pagado ? data.salida.valor_pagado : 0);
  const [valorModificado, setValorModificado] = useState('');
  const [usarValorModificado, setUsarValorModificado] = useState(false);

  const [observacionesEntr, setObservacionesEntr] = useState(data?.entrada?.observaciones)
  const [observacionesSal, setObservacionesSal] = useState(data?.salida?.observaciones ? data.salida.observaciones : 'No ha salido')
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const submitRef = React.useRef(false);

  useEffect(() => {
    axios.get(`${API_URL}/tarifas/`)
      .then(response => {
        setTarifasData(response.data); // Actualizamos el estado con los datos obtenidos
      })
      .catch(error => {
        console.error('Error al realizar la solicitud:', error);
      });
    if (data?.entrada?.fecha_entrada || data?.entrada?.hora_entrada) {
      setFechaEntrada(new Date(`${data.entrada.fecha_entrada}T00:00:00`));
      setHoraEntrada(new Date(`1970-01-01T${data.entrada.hora_entrada}`));
    }
    if (data?.salida?.fecha_salida || data?.salida?.hora_salida) {
      setFechaSalida(new Date(`${data.salida.fecha_salida}T00:00:00`));
      setHoraSalida(new Date(`1970-01-01T${data.salida.hora_salida}`));
    }
  }, [data]);

  useEffect(() => {
    tiempoTranscurridoSettearTodo();
  }, [fechaEntrada, horaEntrada, fechaSalida, horaSalida, data]);

  const tiempoTranscurridoSettearTodo = () => {
    if (fechaEntrada && horaEntrada && fechaSalida && horaSalida) {
      const entrada = new Date(fechaEntrada);
      entrada.setHours(horaEntrada.getHours(), horaEntrada.getMinutes(), horaEntrada.getSeconds());

      const salida = new Date(fechaSalida);
      salida.setHours(horaSalida.getHours(), horaSalida.getMinutes(), horaSalida.getSeconds());

      const diferenciaMs = salida - entrada;
      if (diferenciaMs >= 0) {
        const dias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
        const horas = Math.floor((diferenciaMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutos = Math.floor((diferenciaMs % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((diferenciaMs % (1000 * 60)) / 1000);

        setTiempoTranscurridoMin(Math.floor(diferenciaMs / (1000 * 60)));

        setTiempoTranscurrido(`${dias} días, ${horas} horas, ${minutos} minutos, ${segundos} segundos`);
      } else {
        setTiempoTranscurrido('??');
      }
    }
  }

  const handleSubmit = async (event) => {
    if (submitRef.current || loading) return;
    setSubmitError('');
    submitRef.current = true;
    setLoading(true);
    try {
      const calculatedPayment = calcularPago(tarifa);
      const canonicalPayment = usarValorModificado
        ? parseColombianMoneyInput(valorModificado)
        : normalizeApiMoney(calculatedPayment, { allowNegative: false });

      let movementAdjustment = null;
      if (canonicalPayment !== normalizeApiMoney(valor, { allowNegative: false })) {
        const movimientoId = getId(data.movimiento);
        if (!hasValidId(movimientoId)) {
          throw new Error("Esta estadia historica no tiene movimiento asociado. Puedes cambiar fechas u observaciones, pero no el valor.");
        }
        movementAdjustment = {
          movement_id: movimientoId,
          monto: canonicalPayment,
        };
      }

      let updatedEstadia = { ...data };

      const tarifaData = tarifasData.filter(t => t.id === tarifa);
      updatedEstadia.tarifa = tarifaData[0];

      const pad = n => n.toString().padStart(2, '0');

        const horaEntradaFormateada = horaEntrada
          ? `${pad(horaEntrada.getHours())}:${pad(horaEntrada.getMinutes())}:${pad(horaEntrada.getSeconds())}`
          : '';
        const fechaEntradaFormateada = fechaEntrada
          ? `${pad(fechaEntrada.getDate())}/${pad(fechaEntrada.getMonth() + 1)}/${fechaEntrada.getFullYear()}`
          : '';

        const horaSalidaFormateada = horaSalida
          ? `${pad(horaSalida.getHours())}:${pad(horaSalida.getMinutes())}:${pad(horaSalida.getSeconds())}`
          : '';
        const fechaSalidaFormateada = fechaSalida
          ? `${pad(fechaSalida.getDate())}/${pad(fechaSalida.getMonth() + 1)}/${fechaSalida.getFullYear()}`
          : '';

      const exitUpdate = data.salida !== null
        ? {
          fecha_salida: convertirFecha(fechaSalidaFormateada),
          hora_salida: horaSalidaFormateada,
          valor_pagado: canonicalPayment,
          tiempo_transcurrido: tiempoTranscurrido,
          observaciones: observacionesSal
        }
        : null;
      const entryUpdate = {
        fecha_entrada: convertirFecha(fechaEntradaFormateada),
        hora_entrada: horaEntradaFormateada,
        observaciones: observacionesEntr
      };

      await axios.put(`${API_URL}/estadias/${data.id}/`, {
        tarifa,
        historial: data.historial.id,
        entrada: data.entrada.id,
        movement_adjustment: movementAdjustment,
        entry_update: entryUpdate,
        exit_update: exitUpdate,
      });

      if (data.salida !== null) {
        updatedEstadia.salida = {
          ...data.salida,
          ...exitUpdate,
        };
      }

      updatedEstadia.entrada = {
        ...data.entrada,
        ...entryUpdate,
      };

      if (data.salida !== null)
        await actualizarReporteDiario(data.salida.valor_pagado, canonicalPayment, data.fecha_creacion.split(' ')[0]);

      setValorModificableParaVer(canonicalPayment);
      handleUpdateData(updatedEstadia);
      handleCloseDialog();
    } catch (error) {
      console.error("Error al actualizar la salida:", error);
      setSubmitError(getApiErrorMessage(
        error,
        'No fue posible actualizar la estadía. Revise los datos e intente nuevamente.',
        ['detail', 'historial', 'cliente_recibidor', 'entrada', 'salida', 'tarifa']
      ));
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  };

  function calcularPago(t) {
    if (tarifasData.length === 0)  return -1;
    const tarifaData = tarifasData.filter(tarifaFind => tarifaFind.id === t);

    // Convertir los valores de la tarifa a número
    const tarifaInicial = parseFloat(tarifaData[0].tarifa_inicial);
    const tarifaAdicional = parseFloat(tarifaData[0].tarifa_adicional);
    const horasIniciales = parseInt(tarifaData[0].horas_iniciales, 10);
    const descuento = parseFloat(tarifaData[0].descuento); // Descuento como número
  
    // Convertir minutos a horas (puede ser fraccional)
    const horasTotales = tiempoTranscurridoMin / 60;
    let totalAPagar = 0;
  
    if (horasTotales <= horasIniciales) {
      // Dentro del tramo inicial: se redondea cada fracción de hora hacia arriba.
      const horasCobrar = Math.ceil(horasTotales);
      totalAPagar = horasCobrar * tarifaInicial;
    } else {
      // Se cobran primero las horas iniciales completas...
      const pagoInicial = horasIniciales * tarifaInicial;
      // ...y el tiempo adicional se cobra de forma proporcional.
      const tiempoAdicional = horasTotales - horasIniciales;
      const pagoAdicional = tiempoAdicional * tarifaAdicional;
      totalAPagar = pagoInicial + pagoAdicional;
    }
  
    // Aplicar descuento si existe
    if (descuento > 0) {
      const porcentajeDescuento = descuento / 100;
      totalAPagar = totalAPagar * (1 - porcentajeDescuento);
    }
  
    // Formatear el total con dos decimales
    const resultado = parseFloat(totalAPagar.toFixed(2));
    setValor(resultado);
    return resultado;
  }

  return (
    <Dialog 
      open={openDialog} 
      keepMounted 
      onClose={handleCloseDialog}
      sx={{
        '& .MuiPaper-root': {
          width: '60%',
          maxWidth: 'none',
        },
      }}
    >
      <DialogTitle variant="h4">{"Modificar Estadia"}</DialogTitle>
      <Backdrop
        open={loading}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogContent>
        <Box>

          <TextField fullWidth disabled label="TICKET" value={data.ticket} variant='filled' color="primary" />
          <Typography variant="h6" sx={{ marginTop: 3 }}>Estadia</Typography>
          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>FECHA ENTRADA</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={2}>
              <DatePicker
                value={fechaEntrada}
                onChange={(newValue) => setFechaEntrada(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
              <TimePicker
                value={horaEntrada}
                onChange={(newValue) => setHoraEntrada(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>FECHA SALIDA</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={2}>
              <DatePicker
                disabled={data.salida === null}
                variant={data.salida === null ? 'filled' : 'outlined'}
                value={fechaSalida}
                onChange={(newValue) => setFechaSalida(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
              {data.salida === null && <Typography sx={{ padding: 0, margin: 0 }} color={grey[700]}>¡Crea una salida en Vehiculos Salida!</Typography>}
              <TimePicker
                disabled={data.salida === null}
                variant={data.salida === null ? 'filled' : 'outlined'}
                value={horaSalida}
                onChange={(newValue) => setHoraSalida(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
              {data.salida === null && <Typography sx={{ padding: 0, margin: 0 }} color={grey[700]}>¡Crea una salida en Vehiculos Salida!</Typography>}
            </Stack>
          </LocalizationProvider>
          
          <TextField 
            fullWidth 
            label="TIEMPO TRANSCURRIDO" 
            value={tiempoTranscurrido} 
            variant="filled" 
            disabled
            color='primary'
            InputProps={{ readOnly: true }} 
            sx={{ marginTop: 2 }}
          />

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>TARIFA</Typography>
          <Select
            fullWidth
            value={tarifa || ''}
            onChange={(e) => {setTarifa(e.target.value)}}
          >
              {tarifasData.map((tarifa) => (
                <MenuItem key={tarifa.id} value={tarifa.id}>
                  {`${tarifa.nombre}`}
                </MenuItem>
              ))}
          </Select>

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>PAGO</Typography>
          <TextField 
              autoFocus
              fullWidth
              type="text"
              inputMode="decimal"
              disabled={data.salida === null ? false : (usarValorModificado ? false : true)}
              onChange={(e) => {setValorModificado(e.target.value)}}
              value={
                data.salida !== null
                  ? usarValorModificado
                    ? valorModificado
                    : valor
                  : 'No tienes una Salida Asignada'
              }
              InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }} 
              sx={{ textTransform: 'uppercase' }}
          />
          {data.salida !== null && (
            <Button
              variant="text"
              size="small"
              onClick={() => setUsarValorModificado(prev => !prev)}
              sx={{ mt: 1 }}
            >
              {usarValorModificado ? 'Usar cálculo automático' : 'Usar valor manual'}
            </Button>
          )}
          {usarValorModificado && <Typography sx={{ padding: 0, margin: 0 }} color={grey[100]}>¡Ya no se calculara automaticamente el Pago!</Typography>}

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>OBSERVACIONES ENTRADA</Typography>
          <TextField 
              autoFocus
              fullWidth 
              value={observacionesEntr}
              onChange={(e) => {setObservacionesEntr(e.target.value)}}
              sx={{ textTransform: 'uppercase' }}
          />

          <Typography variant="subtitle2" sx={{ marginTop: 2 }}>OBSERVACIONES SALIDA</Typography>
          <TextField 
              autoFocus
              fullWidth 
              value={observacionesSal}
              disabled={data.salida !== null ? false : true}
              onChange={(e) => {setObservacionesSal(e.target.value)}}
              sx={{ textTransform: 'uppercase' }}
          />
          {data.salida === null && <Typography sx={{ padding: 0, margin: 0 }} color={grey[700]}>¡Crea una salida en Vehiculos Salida!</Typography>}

        </Box>
      </DialogContent>
      {submitError && (
        <Alert severity="error" sx={{ mx: 3, mb: 1 }}>
          {submitError}
        </Alert>
      )}
      <DialogActions>
        <Button onClick={handleCloseDialog} variant="outlined" color="error">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
